
<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <mat-dialog-content>
    <div class="row" *ngIf="employeeList.length > 0">
      <div class="col-sm-4" *ngFor="let item of employeeList">
        <div class="fl_orders" (click)="selectEmployeeToAssign(item)">
          <div class="top_section_order">
            <div class="main-flexc">
              <div class="flex_leftx">
                <div class="ads_sec">
                   <div
                    class="tick_opklads"
                    [ngStyle]="{
                      background: item.selected ? '#1da942' : 'lightgrey'
                    }"
                  >
                    <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
                    <mat-icon
                      class="material-icons-outlined"
                      class="mb-1"
                      style="color: #fff"
                      >check</mat-icon
                    >
                  </div>
                  <div
                    class="hm_icon_progr"
                    *ngIf="item.imgThumbUrl && item.imgThumbUrl != 'null'"
                  >
                    <img [src]="item.imgThumbUrl" />
                  </div>
                  <div
                    class="hm_icon_progr"
                    *ngIf="
                      !item.imgThumbUrl || item.imgThumbUrl == 'null'
                    "
                  >
                    <img src="../../../../assets/images/user-avatar.svg" />
                  </div>
                </div>
              </div>
              <div class="flex_rightx" style="padding-left: 0px;">
                <div class="order_dec" style="padding-left: 20px; padding-top: 10px;">
                 
                  <h3
                    style="
                      -webkit-box-orient: vertical;
                      display: -webkit-box;
                      -webkit-line-clamp: 1;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: normal;
                    "
                  >
                    {{ item.name }}
                  </h3>
                  <p>{{ item.country_code }} {{ item.phone }}</p>
                </div>
                 
              </div>
            </div>
          </div>
           <div *ngIf="item.assigned_slots" style="margin-top: 3px;">

          <div class="time-pill" *ngFor="let item of item.formatted_assigned_slots">
            <div class="count-circle">{{ item.count }}</div>
            <div class="time-text">{{ item.start_time.slice(0,5) }} - {{ item.end_time.slice(0,5) }}</div>
          </div>
        </div>
        <div class="assign_jb" *ngIf="item.selected">
                 <button
                  mat-flat-button
                  color="accent"
                  (click)="onPost()">
                  Assign <mat-icon>arrow_forward</mat-icon>
                </button>
                </div>
        </div>
      </div>
    </div>
    
  </mat-dialog-content>
  
  
  <!-- <mat-dialog-actions align="end" >
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      [disabled]="employeeToAssign.length == 0"
      mat-flat-button
      color="accent"
      (click)="onPost()"
    >
      Assign
    </button>
  </mat-dialog-actions> -->
  